module.exports = "query GetCustomCards($offset: Int, $limit: Int) {\n  cards(limit: $limit, offset: $offset) {\n    ...CustomCardFragment\n  }\n}\n"